var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsedTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 99,
    viewBox: "0 0 125 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 0H0L124.07 99V70.71L36 0Z",
    fill: "url(#paint0_linear_5_3)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.06 18.55L45.75 25.14C45.5832 25.3468 45.4588 25.5845 45.3839 25.8394C45.3089 26.0943 45.285 26.3615 45.3133 26.6257C45.3416 26.8898 45.4217 27.1459 45.5489 27.3791C45.6762 27.6123 45.8482 27.8182 46.055 27.985C46.2618 28.1518 46.4995 28.2762 46.7544 28.3511C47.0093 28.426 47.2765 28.45 47.5407 28.4217C47.8049 28.3934 48.0609 28.3133 48.2941 28.186C48.5273 28.0588 48.7332 27.8868 48.9 27.68L54.21 21.08L55.76 22.33L50.39 29C48.96 30.78 46.88 31.05 44.88 29.44C42.88 27.83 42.71 25.75 44.14 23.97L49.51 17.3L51.06 18.55Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.55 29.15L59.19 27.26L52.68 35.35L51.14 34.11L57.66 26L55.3 24.1L56.36 22.79L62.6 27.79L61.55 29.15Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.74 37.81L63.31 28.41L64.86 29.66L57.29 39.06L55.74 37.81Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.47 31L68 32.2L61.51 40.27L64.8 42.9L63.72 44.24L58.9 40.36L66.47 31Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.58 44.93L72.15 35.53L73.7 36.78L66.13 46.18L64.58 44.93Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M77.66 42.08L73.83 39L74.83 37.72L80.35 42.16L79.35 43.41L69.85 47.08L74 50.4L73 51.68L67.14 47L68.14 45.75L77.66 42.08Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M80.33 53.51L77.54 51.26L74.88 53.26L73.31 52L83.58 44.77L85.4 46.2L80.54 57.78L79 56.52L80.33 53.51ZM81 52.07L82.73 48.23C82.9424 47.7529 83.1829 47.2888 83.45 46.84C83.02 47.24 82.65 47.53 82.27 47.84L78.87 50.35L81 52.07Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M88.94 49.05L91.64 51.22C94.06 53.22 94.25 55.77 91.64 58.94C89.03 62.11 86.4 62.54 83.98 60.59L81.32 58.45L88.94 49.05ZM85 59.4C86.44 60.57 88.21 59.96 90.09 57.63C91.97 55.3 92.15 53.55 90.68 52.37L89.57 51.48L83.9 58.48L85 59.4Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M92.35 59.53C95.13 56.08 97.6 55.63 99.87 57.46C102.14 59.29 102.21 61.79 99.44 65.23C96.67 68.67 94.18 69.13 91.93 67.32C89.68 65.51 89.58 63 92.35 59.53ZM97.81 63.92C99.96 61.24 100.09 59.71 98.81 58.72C97.53 57.73 96.07 58.15 93.92 60.83C91.77 63.51 91.67 65.06 92.92 66.05C94.17 67.04 95.65 66.61 97.81 63.92Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_3",
    x1: 0,
    y1: 49.5,
    x2: 124.07,
    y2: 49.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A74A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16A74A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsedTag);
export default __webpack_public_path__ + "static/media/used-tag.a15a00bbb2b067a943ff5f1619346d2d.svg";
export { ForwardRef as ReactComponent };